import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
// import { FormGroup, Input as ReactInput, Label } from "@vzrf/react-forms";
import { Input } from "@vds/inputs";
import { TitleLockup } from "@vds/type-lockups";
import { Feature,Body,Title } from "@vds/typography"
import { TextLink } from "@vds/buttons";

import { Redirect } from "react-router-dom";
import { convertStringToElements } from "@vds/html-parsers";

import { media, isMobile } from "utils/style";
import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { replaceHashValues } from "utils/replaceHashValues";
import styled from "styled-components";

import { clearErrors, } from "../DownloadAndDelete/actions";
import { validateSecurePin, sendSecurePinToDevice, checkPendingCases, createUpdateProfile, createCase } from "./actions/commonFormerCustomerAPI";
import Button from "common-components/Buttons";
import CommonContainer from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import Alert from "common-components/Alert";
import { encryptData, decryptData } from "utils/decryptData";
import PropTypes from "prop-types";
import FetchPageContent from "../../../hoc/FetchPageContent";
import { FormerPendingRequest } from "./FormerPendingRequest";
import Warning from "../../../../assets/svgs/Warning.svg";
import { MaxAttemptsModal } from "./modals";

class FormerCustomerOTPScreen extends Component {
    state = {
        showSuccessMessage: false,
        errorRequestingPin: false,
        pinLength: 0,
        pendingModal: false,
        showMaxAttemptsModal: false,
        errorCheck: true
    };
    InputRef= React.createRef();

    componentDidMount() {
        if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
            this.props.setA11yContent("Former Download OTP Authentication", this.props.pageContent.sc_pagetitle);
        }
    }

    componentWillUnmount() {
        this.props.clearErrors();
    }

    componentDidUpdate() {
        let message;
        if (this.props.error && this.isJson(this.props.error)) {
            let errorObj = JSON.parse(this.props.error);
            if (errorObj.message && errorObj.message.length > 0) {
                message = errorObj.message.toLowerCase();
                if (this.state.errorCheck) {
                    if (message.includes("maximum")) {
                        this.setState({ showMaxAttemptsModal: true }, () => { this.setState({ errorCheck: false }) })
                    }
                }
            }
        } else if (this.props.error && !(this.isJson(this.props.error))) {
            message = this.props.error.toLowerCase();
            if (this.state.errorCheck) {
                if (message.includes("maximum")) {
                    this.setState({ showMaxAttemptsModal: true }, () => { this.setState({ errorCheck: false }) })
                }
            }
        }
    }

    codeContinuous= (inputVal) => {
        let digit= inputVal.split('').map(Number);
        let isAscending = false;
        let isDescending = false; 
        let isSame = false; 
        
        for(let i = 1 ; i< digit.length; i++) {
            if( digit[i] !== digit[i -  1] + 1) isAscending = true;
            if( digit[i] !== digit[i -  1] - 1) isDescending = true;
            if( digit[i] !== digit[i -  1]) isSame = true;
        }
        
        return isAscending && isDescending && isSame;
    }

    isJson = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    handleSubmit = e => {
        e.preventDefault();
        const { uuid, location } = this.props;
        this.setState({ showSuccessMessage: false, errorRequestingPin: false });
        if (this.props.location && this.props.location.state) {
            const inputVal = this.InputRef.current.value;  // getElementById("multifactor_authentication")
            let flow = location.state.data.currentIntent ? location.state.data.currentIntent : "";
            let serviceType = location.state.data.serviceType ? location.state.data.serviceType : "";
            if (this.state.pinLength !== 10) {
                this.props.validateSecurePin(inputVal, flow, uuid).then(() => {
                    if (!this.props.error && this.codeContinuous(inputVal) && encryptData(inputVal) === this.props.byPassEmail) {
                        this.resetInputValue();
                        this.setState({ pinLength: 0 });
                        if (!this.props.error) {
                            this.setState({ pinLength: 10 });
                            const { state } = this.props.location;
                            if (state.resendPWFlow) {
                                // this.resendPassword();
                            } else {
                                var data = {
                                    emailId: this.props.location.state.data.emailId ? this.props.location.state.data.emailId : null,
                                    fname: this.props.location.state.data.fname ? this.props.location.state.data.fname : null,
                                    lname: this.props.location.state.data.lname ? this.props.location.state.data.lname : null,
                                    currentIntent: flow ? flow : null,
                                    serviceType: serviceType ? serviceType : null,
                                    isOptOut: this.props.location.state.data.isOptOut ? this.props.location.state.data.isOptOut : null,
                                    isMobilePage: this.props.location.state.data.isMobilePage ? this.props.location.state.data.isMobilePage : null
                                }
                                let intent = flow === "delete" ? "Delete" :
                                    flow === "correct" ? "Correct" : "Download"

                                var DeleteisOptOut = this.props.location && this.props.location.state && this.props.location.state.data.isOptOut ? this.props.location.state.data.isOptOut : null;
                                this.props.checkPendingCases(data.emailId, intent, DeleteisOptOut, data.serviceType).then(() => {

                                    if (!this.props.error) {
                                        if (this.props.isCasePending) {
                                            this.setState({ pendingModal: true })
                                        } else {
                                            if ((serviceType === "former" &&
                                                data.isMobilePage === "N" &&
                                                data.isOptOut === "Y") ||
                                                (serviceType === "guest" &&
                                                    data.isMobilePage === "N")) {
                                                this.props.history.replace(
                                                    {
                                                        pathname: "mobile-info",
                                                        state: { data: data }
                                                    }
                                                );
                                            } else {
                                                var datas = {
                                                    emailId: data.emailId,
                                                    firstName: data.fname,
                                                    lastName: data.lname,
                                                    action: flow,
                                                    flow: "createProfile",
                                                    uuid: uuid,
                                                    isOptOut: data.isOptOut,
                                                    serviceType: data.serviceType,
                                                    formerId: this.props.formerId,
                                                    accountId: this.props.accountInfo
                                                }
                                                this.props.createUpdateProfile(datas).then(() => {
                                                    if (!this.props.error) {
                                                        this.props.createCase(data.emailId, uuid, data.fname, data.lname, intent, data.isOptOut, data.serviceType).then(() => {
                                                            if (!this.props.error) {
                                                                this.props.history.replace(
                                                                    {
                                                                        pathname: "address_dob",
                                                                        state: { data: data }
                                                                    }
                                                                );
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        }
                                    }
                                })
                            }
                        }
                    } else {
                        this.setState({ errorRequestingPin: true });
                    }
                });
            } else {
                // this.resendPassword();
            }
        }
    };

    resendSecurePin = () => {
        this.resetInputValue();
        this.setState({ errorRequestingPin: false, showSuccessMessage: false, pinLength: 0 });

        const { location } = this.props;
        let email = location.state.data.emailId
        var flow = location.state.data.currentIntent === "delete" ? "Delete" : location.state.data.currentIntent === "correct" ? "Correct" : "Download"
        var isMobilePage = location.state.data.isMobilePage


        let formerId;
        if (this.props.location.state.data && this.props.location.state.data.formerUuid) {
            formerId = this.props.formerId ? this.props.formerId : null
        }

        this.props.sendSecurePinToDevice(encryptData(email), flow, isMobilePage, null, formerId).then(() => {
            if (!this.props.error) {
                this.setState({ showSuccessMessage: true });
            } else {
                this.setState({ errorRequestingPin: true});
            }
        });
    };

    handleKeyPress = e => {
        const charCode = e.which ? e.which : e.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            e.preventDefault();
            return false;
        }
        return true;
    };

    resetInputValue = () => {
        
        this.InputRef.current.value = ""; //getElementById("multifactor_authentication")

    };

    updatePinLength = () => {
        this.setState({  pinLength: this.InputRef.current.value.length }); // getElementById("multifactor_authentication")
        if (this.state.errorRequestingPin) {
            this.setState({ errorRequestingPin: false })
        }
        if (this.props.error) {
            this.props.clearErrors();
        }

        if (this.state.showSuccessMessage) {
            this.setState({ showSuccessMessage: false });
        }
    };

    closeMaxAttemptsModal = () => {
        this.setState({ showMaxAttemptsModal: false })
        const serviceType = this.props.location.state &&
            (this.props.location.state.serviceType ?
                this.props.location.state.serviceType :
                (this.props.location.state.data && this.props.location.state.data.serviceType ?
                    this.props.location.state.data.serviceType : null
                ));
        if (serviceType === "former") {
            this.props.history.replace({
                pathname: "/privacy/your-data/former-customer"
            })
        } else if (serviceType === "guest") {
            this.props.history.replace({
                pathname: "/privacy/your-data/guest-landing"
            })
        }
    }

    render() {
        const { pageContent, loading, requestPending, location, maxAttemptsModal } = this.props;

        if (!pageContent) {
            if (location.state.data.serviceType === "former") {
                return <Redirect to="/privacy/your-data/former-customer" />;
            } else if (location.state.data.serviceType === "guest") {
                return <Redirect to="/privacy/your-data/guest-landing" />;
            }
        }
        if (loading) {
            return <RectangleLoader id="formerLoader" />;
        }

        return (
            <Fragment>
                <Container>
                    <Fragment>
                    {/* VDS DPCMP-3786 ,DPCMP-3784 */}

                    <TitleLockup
                        viewport={isMobile ? "mobile": "desktop"}
                        data={{
                        title: {
                            size: 'titleXLarge',
                            bold: false,
                            // primitive: 'h1',
                            children: pageContent.section_title
                        },
                        subtitle : {
                            size: 'titleMedium',
                            primitive: 'p',
                            children: <Body size="medium">
                                        {convertStringToElements(
                                            replaceHashValues(pageContent.section_description, {
                                            notificationemail: this.props.emailAddress ? this.props.emailAddress : null
                                        })
                                        )}
                                     </Body>
                        }                  
                        }}
                    />
                        
                        <form onSubmit={this.handleSubmit}>
                            <Form style={{ marginBottom: "0" }}>
                                <InputContainer>
                                    
                                    <Input
                                        name="pin"
                                        label={pageContent.genericList[0].list[0].jsonKey}
                                        type="password"
                                        ref={this.InputRef}
                                        data-testid="multifactor_authentication"
                                        required={true}
                                        readOnly={false}
                                        error={this.props.error || this.state.errorRequestingPin ? true : false}
                                        errorText={this.props.resendPWError ? convertStringToElements(this.props.resendPWError) : this.props.error && this.state.errorRequestingPin ? convertStringToElements(this.props.error) : this.props.error}
                                        // className={this.props.error || this.state.errorRequestingPin ? "icon" : ""}
                                        id="multifactor_authentication"
                                        data-qm-encrypt="true"
                                        maxLength="6"
                                        autoComplete="off"
                                        aria-describedby="multifactor_authentication_error"
                                        onKeyPress={this.handleKeyPress}
                                        onChange={this.updatePinLength}
                                    />
                                    {(this.props.error || this.state.errorRequestingPin || this.state.resendPWError) && (
                                        this.state.showMaxAttemptsModal ?
                                            <MaxAttemptsModal
                                                modalContent={maxAttemptsModal}
                                                closeModal={this.closeMaxAttemptsModal}
                                            />
                                            :
                                        null )}
                                </InputContainer>
                            </Form>
                            <Body size="large">
                                {pageContent.genericList[0].list[1].text}
                            <TextLink 
                                type="inline" 
                                onClick={e => this.resendSecurePin()}>
                                {pageContent.genericList[0].list[1].jsonValue}
                            </TextLink>
                            </Body>
                           
                            <Button
                                type="submit"
                                disabled={this.state.pinLength < 6}
                                style={{ marginTop: "48px" }}
                                background={pageContent.buttons[0].type}
                            >
                                {pageContent.buttons[0].text}
                            </Button>
                        </form>
                    </Fragment>
                </Container>
                {this.state.showSuccessMessage ? (
                    <Alert alertType="success" afterCloseRequest={() => this.setState({ showSuccessMessage: false })}>
                        {convertStringToElements(pageContent.genericList[0].list[2].jsonValue)}
                    </Alert>
                ) : null}
                {this.state.pendingModal ?
                    <FormerPendingRequest
                        modalContent={requestPending}
                        dateOfRequest={"date"}
                        closeModal={() => {
                            this.setState({
                                pendingModal: !this.state.pendingModal
                            }, () => {
                                if (location.state.data.serviceType === "former") {
                                    this.props.history.push("/privacy/your-data/former-customer")
                                } else if (location.state.data.serviceType === "guest") {
                                    this.props.history.push("/privacy/your-data/guest-landing")
                                }
                            })
                        }}
                    /> : ""
                }

            </Fragment>
        );
    }
}

FormerCustomerOTPScreen.propTypes = {
    setA11yContent: PropTypes.func.isRequired,
    pageContent: PropTypes.object
};

const mapStateToProps = ({
    modalState,
    pageContent,
    loadingAndErrorState,
    verifiedSecurePinDevice,
    // downloadAndDelete: { uniqueTxnId },
    formerCustomer: { formerId, accountInfo },
    pendingCase: { isCasePending, byPassEmail },
    getUuid: { uuid, emailAddress }
}) => ({
    showModal: modalState.showModal,
    loading: loadingAndErrorState.loading,
    error: loadingAndErrorState.error,
    resendPWError: loadingAndErrorState.resendPWError,
    pageContent: pageContent.email_otp,
    // verifiedDevice: verifiedSecurePinDevice.verifiedDevice,
    // uniqueTxnId,
    isCasePending,
    formerId,
    accountInfo,
    requestPending: pageContent.pending_modal,
    maxAttemptsModal: pageContent.maximum_attempts_reached,
    uuid,
    emailAddress,
    byPassEmail
});

export default compose(
    connect(
        mapStateToProps,
        {
            validateSecurePin,
            setA11yContent,
            sendSecurePinToDevice,
            clearErrors,
            checkPendingCases,
            createUpdateProfile,
            createCase
        }
    ),
    FetchPageContent
)(FormerCustomerOTPScreen);


const ErrorMsg = styled.span`
  display: block;
  font-size: 10px;
  line-height: 10px;
  font-family: "Verizon-NHG-eTX", Helvetica, Arial, sans-serif;
  max-width: 325px;
  margin-top: 5px;

  ${media.mobile`
    max-width: 100%;  
  `}
`;

const P = styled.p`
  margin-top: 24px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
`;

const ResendCodeButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  text-decoration: underline;
  cursor: pointer;
  font-size: 16px;
  line-height: 20px; 
  padding-left :2px;
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  width: 596px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  padding-bottom: 12px;
  font-weight: 300;

  ${media.mobile`
    max-width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 36px;
    font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;

const Div = styled.div`
  max-width: 596px;
  letter-spacing: 0.5px;
 
  p {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 20px;
  }
`;
const Form = styled.form`
max-width: 385px;
/*border-top: 4px solid #000;*/
padding-top: 2px;
`;

// const Input = styled(ReactInput)`
//   width: 328px;
//   max-width: 424px;
//   border: 1px solid #6F7171;
//   border-radius: 4px;
//   ${media.mobile`
//     width: 100%;
//   `}
// `;

const InputContainer = styled.div`
  flex: 50%;
  margin-top: 32px;
  margin-bottom: 5px;

  div {
    display: block;
  }

  .icon {
    padding-left: 25px;
    background: url(${Warning})no-repeat left;
    background-size: 20px;
    background-position: 99%;
    border: 1px solid  #C44904 !important;
    background-color:#FBE4D7;
    border-radius: 4px;
  }

  ${media.mobile`
    flex: 100%;
  `}
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: "0";
 padding: 48px 16px ;
  `}
`;